import { Component } from '@angular/core';

@Component({
    selector: 'app-report-view',
    templateUrl: './report-view.component.html',
    styleUrls: ['./report-view.component.scss'],
    standalone: false
})
export class ReportViewComponent {}
